import { render, staticRenderFns } from "./FailedChecks.vue?vue&type=template&id=173e0f30&"
import script from "./FailedChecks.vue?vue&type=script&lang=js&"
export * from "./FailedChecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports